import styled from 'styled-components';
export const TooltipContent = styled.div `
  padding: var(--space-100);
  background: var(--bg-primary);
  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
`;
